<script setup lang="ts">
export default {
  props: {
		letter: { type: String, required: true },
		title: { type: String, required: true },
		items: { type: Array, required: true },
  },
}
</script>

<template>
	<div class="flex flex-col">
		<div class="flex items-center gap-5">
			<span
				class="flex-shrink-0 flex justify-center items-center bg-grey-700 rounded-full text-white font-header text-sm font-medium leading-tight tracking-widest uppercase"
				style="width: 28px; height: 28px;"
			>{{ letter }}</span>
			<h4
				class="font-header text-grey-700 text-lg font-medium leading-tight tracking-widest uppercase"
			>{{ title }}</h4>
		</div>
		<ol
			class="mt-3 list-decimal flex flex-col gap-1.5"
			style="margin-left: 72px;"
		>
			<li
				v-for="item in items"
				:key="item"
				class="text-base font-medium"
				style="color: #89817E;"
			>{{ item }}</li>
		</ol>
	</div>
</template>
